import { render, staticRenderFns } from "./AccountSimple.vue?vue&type=template&id=a7585dcc&"
import script from "./AccountSimple.vue?vue&type=script&lang=js&"
export * from "./AccountSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports